import React from "react";
import ReactLoader from "react-loaders";

const Loader = ({active}) => <ReactLoader active={active} type="line-scale-pulse-out" />;

export default Loader;
